/**
 * Hook useEntity - Récupération des données d'une entité (commune/EPCI)
 * Version moderne avec TanStack Query
 */
import { useQuery } from '@tanstack/react-query';
import { getEntity } from '../../services/entities';

/**
 * Hook pour récupérer les données d'une entité
 * @param {string} insee - Code INSEE de l'entité
 * @returns {Object} Résultat de la requête avec data, isLoading, error
 */
const useEntity = (insee) => useQuery({
  queryKey: ['entity', insee],
  queryFn: () => getEntity(insee),
  enabled: !!insee,
  staleTime: 1000 * 60 * 10, // 10 minutes
  gcTime: 1000 * 60 * 30, // 30 minutes
  retry: (failureCount, error) => {
    // Ne pas réessayer si l'entité n'existe pas (404)
    if (error?.status === 404) return false;
    return failureCount < 2;
  },
});

export default useEntity;
